/* eslint-disable max-len */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import defaultPhoto from 'assets/img/image-placeholder.jpg';
import Img from 'modules/common/components/Img';

function Requirements({ businessRequirements, laboratoryRequirements }) {
  const businessTabList = businessRequirements || [];
  const laboratoyTabList = laboratoryRequirements || [];

  const [laboratoryRequirementTab, setLaboratoryRequirementTab] = useState(0);
  const [businessRequirementTab, setBusinessRequirementTab] = useState(0);

  const handleChangeLaboratoryRequirementTab = (location) => () => {
    setLaboratoryRequirementTab(location);
  };

  const handleChangeBusinessRequirementTab = (location) => () => {
    setBusinessRequirementTab(location);
  };

  return (
    <>
      {laboratoryRequirements && (
        <div className="d-flex flex-column border m-3 py-3">
          <h3 className="ml-3 font-weight-bold">Laboratory</h3>
          <div className="d-flex">
            {!_.isEmpty(laboratoyTabList) ? (
              <>
                {/* TABS */}
                <div
                  className="col-6"
                  style={{ height: '9.60rem', overflowY: 'scroll' }}
                >
                  <div className="form-wrapper arrow-card">
                    {laboratoyTabList.map((item, i) => (
                      <div
                        key={item.id}
                        role="presentation"
                        className="arrow-cell p-3 btn-blank"
                        onClick={handleChangeLaboratoryRequirementTab(i)}
                      >
                        <div className="font-weight-bold">
                          {_.get(item, 'attributes.name')}
                        </div>
                        {i === laboratoryRequirementTab ? (
                          <div className="arrow" />
                        ) : (
                          ''
                        )}
                      </div>
                    ))}
                  </div>
                </div>
                {/* IMAGE HOLDER */}
                <div className="col-6">
                  <div className="form-wrapper preview-image">
                    <React.Fragment>
                      {laboratoyTabList.map(
                        (
                          item,
                          i // MAP AND CHECK IF ITEM IS EQUAL TO ACTIVE TAB
                        ) =>
                          i === laboratoryRequirementTab ? (
                            <Img
                              key={item.id}
                              src={_.get(item, 'attributes.url')}
                              className="shadow-lg"
                              role="presentation"
                              defaultSrc={defaultPhoto}
                              width="80%"
                              alt=""
                            />
                          ) : (
                            ''
                          )
                      )}
                    </React.Fragment>
                  </div>
                </div>
              </>
            ) : (
              <div
                className="d-flex justify-content-center w-100"
                style={{ height: '13rem' }}
              >
                <h4 className="">No requirements found</h4>
              </div>
            )}
          </div>
        </div>
      )}
      {businessRequirements && (
        <div className="d-flex flex-column border m-3 py-3">
          <h3 className="ml-3 font-weight-bold">Inquired Business</h3>
          <div className="d-flex">
            {!_.isEmpty(businessTabList) ? (
              <>
                {/* TABS */}
                <div
                  className="col-6"
                  style={{ height: '9.60rem', overflowY: 'scroll' }}
                >
                  <div className="form-wrapper arrow-card">
                    {businessTabList.map((item, i) => (
                      <div
                        key={item.id}
                        role="presentation"
                        className="arrow-cell p-3 btn-blank"
                        onClick={handleChangeBusinessRequirementTab(i)}
                      >
                        <div className="font-weight-bold">
                          {_.get(item, 'attributes.name')}
                        </div>
                        {i === businessRequirementTab ? (
                          <div className="arrow" />
                        ) : (
                          ''
                        )}
                      </div>
                    ))}
                  </div>
                </div>
                {/* IMAGE HOLDER */}
                <div className="col-6">
                  <div className="form-wrapper preview-image">
                    <React.Fragment>
                      {businessTabList.map(
                        (
                          item,
                          i // MAP AND CHECK IF ITEM IS EQUAL TO ACTIVE TAB
                        ) =>
                          i === businessRequirementTab ? (
                            <Img
                              key={item.id}
                              src={_.get(item, 'attributes.url')}
                              className="shadow-lg"
                              role="presentation"
                              defaultSrc={defaultPhoto}
                              width="80%"
                              alt=""
                            />
                          ) : (
                            ''
                          )
                      )}
                    </React.Fragment>
                  </div>
                </div>
              </>
            ) : (
              <div
                className="d-flex justify-content-center w-100"
                style={{ height: '13rem' }}
              >
                <h4 className="">No requirements found</h4>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
}

Requirements.propTypes = {
  businessRequirements: PropTypes.oneOfType([PropTypes.bool, PropTypes.array]),
  laboratoryRequirements: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.array,
  ]),
};

Requirements.defaultProps = {
  businessRequirements: false,
  laboratoryRequirements: false,
};

const mapStateToProps = () => ({});

const enhance = _.flowRight([withRouter, connect(mapStateToProps)]);

export default enhance(Requirements);
